import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-shimmer',
  templateUrl: './table-shimmer.component.html',
  styleUrls: ['./table-shimmer.component.scss']
})
export class DashboardTableShimmerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
